import React from "react";
import { TStaticDrawFunction } from "../../../Components/Canvas";
import { MeasurementChartPainter } from "./MeasurementChartPainter";
import MeasurementChart from "./MeasurementChart";
import useControlAttribute from "../../../hooks/useControlAttribute";
import { IControl } from "../types";
import useControlMeasurements from "../../../hooks/useControlMeasurements";
import { useTranslation } from "react-i18next";

interface IPelletsLevelChartProps {
  control: IControl;
  width: number;
  height: number;
}

const PelletsLevelChart = (props: IPelletsLevelChartProps) => {
  const { control, width, height } = props;
  const value = useControlAttribute(control, "pellets_level_percent");
  const { valuesList } = useControlMeasurements(control, ["pellets_level"]);
  const { t } = useTranslation();

  if (!valuesList) {
    return null;
  }

  const draw: TStaticDrawFunction = (ctx) => {
    const chart = new MeasurementChartPainter(width, height);
    chart.drawPercentBars(ctx, valuesList[0]);
  };

  return (
    <MeasurementChart
      title={t("Pellets Level") + `: ${value}%`}
      draw={draw}
      width={width}
      height={height}
    />
  );
};

export default PelletsLevelChart;
